import { StanModal } from '@/components';
import { useStanRouter } from '@/hooks/useStanRouter';
import { useEffect, useState } from 'react';
import { OTPInput } from './OTPInput';
import { useMFA } from '../hooks/useMFA';

export function MFAModal({
    isOpen,
    loginEndpoint,
    token,
    configName,
    onSuccess,
    onClose,
}: {
    isOpen: boolean;
    onClose: () => void;
    loginEndpoint: string;
    token: string;
    configName?: string;
    onSuccess?: () => void;
}) {
    const [resetKey, setResetKey] = useState(0);
    const { resetWarningsAndErrors, validateConfigOTP, error, warning } = useMFA(token, loginEndpoint, onSuccess);
    const [showRecoveryTextInput, setShowRecoveryTextInput] = useState(false);

    const { push } = useStanRouter();

    useEffect(() => {
        if (showRecoveryTextInput) {
            push('/login');
        }
    }, [showRecoveryTextInput, push]);

    useEffect(() => {
        if (!isOpen) {
            resetWarningsAndErrors();
            setResetKey(key => key + 1);
        }
    }, [isOpen, resetWarningsAndErrors, setResetKey]);

    return (
        <StanModal title='Verify Code' id='mfa-validation modal' isOpen={isOpen} onClose={onClose}>
            {!showRecoveryTextInput && (
                <div>
                    <div className='text-dark flex flex-col items-center text-center'>
                        <p className='text-light m-1'>
                            Enter the one-time code from{' '}
                            <strong>{configName === '' ? 'authenticator app' : configName}</strong> to complete
                            authentication
                        </p>
                    </div>
                    <OTPInput
                        error={error && error.errors && error.errors.otp ? error.errors.otp : []}
                        warning={warning}
                        onResetErrors={resetWarningsAndErrors}
                        submitButtonText='Continue'
                        onSubmit={validateConfigOTP}
                        onShowRecovery={() => setShowRecoveryTextInput(true)}
                        showHelpAndRecovery
                        key={resetKey}
                    />
                </div>
                // TODO: Add recovery text input later
                // ) : (
                //     <div>
                //         <div className='mfa-modal-header'>
                //             <h3 className='text-bold mb-2'>Enter your recovery code</h3>
                //             <p className='modal-pretext text-light'>
                //                 Use the one-time-use recovery code you saved during 2FA setup to sign-in
                //             </p>
                //         </div>
                //         <RecoveryTextInput
                //             error={error}
                //             warning={warning}
                //             onResetErrors={resetWarningsAndErrors}
                //             submitButtonText='Continue'
                //             onSubmit={submitRecoveryText}
                //             onShowOTP={() => setShowRecoveryTextInput(false)}
                //             loading={isLoading}
                //         />
                //     </div>
            )}
        </StanModal>
    );
}
